
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import MaintenancePage from './components/MaintenancePage/MaintenancePage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      {/* <MaintenancePage/> */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
